import { DisclosureArrow } from "../../disclosure";
import { IconButton } from "../../button";
import { Item } from "../../collection";
import { Menu, MenuTrigger } from "../../menu";
import { useRef } from "react";
import { useEventCallback } from "../../shared";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MenuPresets({
  onSelectionChange,
  selectedIndex,
  values
}) {
  const presetButtonRef = useRef();
  const handleSelectPreset = useEventCallback((event, keys) => {
    var _presetButtonRef$curr;

    onSelectionChange(event, parseInt(keys[0]));
    (_presetButtonRef$curr = presetButtonRef.current) === null || _presetButtonRef$curr === void 0 ? void 0 : _presetButtonRef$curr.focus();
  });
  return /*#__PURE__*/_jsxs(MenuTrigger, {
    children: [/*#__PURE__*/_jsx(IconButton, {
      "aria-label": "Date presets",
      ref: presetButtonRef,
      children: /*#__PURE__*/_jsx(DisclosureArrow, {})
    }), /*#__PURE__*/_jsx(Menu, {
      onSelectionChange: handleSelectPreset,
      selectedKeys: [selectedIndex === null || selectedIndex === void 0 ? void 0 : selectedIndex.toString()],
      selectionMode: "single",
      children: values.map((x, index) =>
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      _jsx(Item, {
        children: x
      }, index.toString()))
    })]
  });
}